import React from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Loader from 'epn-ui/umd/dist/components/Loader';
import Input from 'epn-ui/umd/dist/components/InputText';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { toast } from 'react-toastify';
import useI18n from '@i18n';

import BaseToast from '@base/BaseToast';

import apiHooks from '@apiHooks';
import copyTextToClipboard from '@utils/clipboard';

import { IGetCreativesDataFormatted, IGetCreativesBannersDataFormatted } from '@api/types';

const { useCreativeBanners } = apiHooks;

export interface IModalBannerListProps {
    data: IGetCreativesDataFormatted;
    onClose: () => void;
}

const ModalBannerList: React.FC<IModalBannerListProps> = ({ data: { id, sizes }, onClose }) => {
    const { t } = useI18n('Creatives');
    const { t: tCommon } = useI18n('Common');

    const { data: bannersData, isLoading, error } = useCreativeBanners<
        IGetCreativesBannersDataFormatted[]
    >({
        urlParams: { id },
    });

    const onCopyMessage = async link => {
        await copyTextToClipboard(link);
        toast.success(<BaseToast text={t('Link copied')} type="success" />, {
            toastId: link,
        });
    };

    const requestId = error?.response?.headers?.get('request-id');

    return (
        <Dialog title={t('Banner list')} onCancel={onClose} open>
            <div id="modal-banner-list">
                {isLoading && <Loader />}
                {error && (
                    <div className="p-20 text-center text-p1">
                        {tCommon('Failed to load data')}{' '}
                        {requestId && <p className="font-medium">request-id: {requestId}</p>}
                    </div>
                )}
                {!isLoading && !error && (
                    <>
                        {bannersData?.length ? (
                            bannersData?.map(({ id: bannerId, src, link }) => (
                                <div key={bannerId} className="mb-8 overflow-auto">
                                    <div className="relative mb-2">
                                        <img src={src} alt="banner" />
                                        <span className="absolute px-4 bg-white py-1.5 opacity-90 rounded-[20px] left-[7px] bottom-[9px] text-p2 text-blueGray-800">
                                            {sizes}
                                        </span>
                                    </div>
                                    <Input
                                        value={link}
                                        readOnly
                                        prefix={
                                            <FontAwesomeIcon
                                                icon={faCopy}
                                                onClick={() => onCopyMessage(link)}
                                            />
                                        }
                                    />
                                </div>
                            ))
                        ) : (
                            <p className="text-center">{tCommon('List is empty')}</p>
                        )}
                    </>
                )}
            </div>
        </Dialog>
    );
};

export default ModalBannerList;
